import { useAuth0 } from '@auth0/auth0-react';
import { useQuery } from '@tanstack/react-query';
import { getAdminMe } from '../services/api';

/** Whether the signed-in user has the read:admin permission (asks the backend once per session; false otherwise). */
export const useIsAdmin = (): boolean => {
  const { isAuthenticated } = useAuth0();
  const q = useQuery({
    queryKey: ['adminMe'],
    queryFn: getAdminMe,
    enabled: isAuthenticated,
    staleTime: Infinity,
    retry: false,
  });
  return isAuthenticated && q.data === true;
};
